<template>
  <MDBScrollbar>
    <div v-for="(group, key) in groupedEmployees" :key="key">
      <div class="group-header">{{ key }}</div>
      <div v-for="employee in group" :key="employee.employeeId">
        <ProjectTaggingDrawerListRow :employee="employee" />
      </div>
    </div>
  </MDBScrollbar>
</template>

<script>
import { MDBScrollbar } from 'mdb-vue-ui-kit';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';
import ProjectTaggingDrawerListRow from './ProjectTaggingDrawerListRow.vue';
export default {
  components: {
    MDBScrollbar,
    ProjectTaggingDrawerListRow,
  },
  setup() {
    const projectTagging = useProjectTaggingStore();
    const { drawerEmployeeList } = storeToRefs(projectTagging);

    const groupedEmployees = computed(() => {
      return drawerEmployeeList.value.reduce((groups, employee) => {
        let firstLetter = employee.lastName.charAt(0).toUpperCase();
        if (!groups[firstLetter]) {
          groups[firstLetter] = [];
        }
        let entry = groups[firstLetter];
        entry.push(employee);
        return groups;
      }, {});
    });
    return {
      projectTagging,
      groupedEmployees,
    };
  },
};
</script>
<style lang="scss" scoped>
.group-header {
  padding: 12px 0;
  font-size: 12px;
  color: $neutral-200;
}
.spinner-border {
  border-color: $neutral-300;
  border-right-color: transparent;
}
.ps {
  padding-right: 14px;
}
</style>
